import { readableError } from 'utils/error'

import { R_GLOBAL } from 'reducer/global'

import { NOTIFY_LEVELS, R_NOTIFY } from './reducer'

function notifyMessage(type, value) {
  return {
    type: R_GLOBAL.NOTIFY,
    value: {
      type,
      value
    }
  }
}

export const notifier = {
  notify(dispatch, type, content) {
    dispatch(notifyMessage(R_NOTIFY.PUSH, { type, content }))
  },
  error(dispatch, content) {
    dispatch(notifyMessage(R_NOTIFY.PUSH, { type: NOTIFY_LEVELS.ERROR, content }))
  },
  warn(dispatch, content) {
    dispatch(notifyMessage(R_NOTIFY.PUSH, { type: NOTIFY_LEVELS.WARN, content }))
  },
  info(dispatch, content) {
    dispatch(notifyMessage(R_NOTIFY.PUSH, { type: NOTIFY_LEVELS.INFO, content }))
  },
  editing(dispatch) {
    dispatch(notifyMessage(R_NOTIFY.EDITING))
  },
  saved(dispatch, success = true) {
    dispatch(notifyMessage(R_NOTIFY.SAVED, { success }))
  },
  expire(dispatch) {
    dispatch(notifyMessage(R_NOTIFY.EXPIRE))
  },
  noexpire(dispatch, id) {
    dispatch(notifyMessage(R_NOTIFY.NOEXPIRE, id))
  },
  remove(dispatch, id) {
    dispatch(notifyMessage(R_NOTIFY.REMOVE, id))
  },
  onCatch(dispatch) {
    return (err) => notifier.error(dispatch, readableError(err))
  }
}

export { readableError }
export default notifier
